import { render } from "./manageWatchListDialog.vue?vue&type=template&id=279395c6"
import script from "./manageWatchListDialog.vue?vue&type=script&lang=js"
export * from "./manageWatchListDialog.vue?vue&type=script&lang=js"

import "./manageWatchListDialog.vue?vue&type=style&index=0&id=279395c6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__